// For reference: https://github.com/dcousens/haversine-distance/blob/main/index.js
const {atan2, sqrt, sin, cos} = Math;

type Coordinates = {
  latitude: number;
  longitude: number;
}

// Equatorial mean radius of Earth (m)
const R = 6378137

function toRad (x: number) { return x * Math.PI / 180.0 }

function haversine (x: number) {
  return sin(x / 2) ** 2
}

// Calculate the distance between two gps coordinates (m)
export function haversineDistance (a: Coordinates, b: Coordinates) {
  const aLat = toRad(a.latitude)
  const aLng = toRad(a.longitude)
  const bLat = toRad(b.latitude)
  const bLng = toRad(b.longitude)

  // Haversine central angle
  const ht = haversine(bLat - aLat) + cos(aLat) * cos(bLat) * haversine(bLng - aLng)

  return 2 * R * atan2(sqrt(ht), sqrt(1 - ht))
}